import { useQuery } from '@tanstack/react-query';
import { getOrganisations } from '../api';

export function useOrganisations() {
  return useQuery({
    queryKey: ['onboarding', 'organisations'],
    queryFn: getOrganisations,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
